import { useEffect } from "react";
import { createPortal } from "react-dom";
import { getAppPortalRoot } from "../utils/appPortal";
import { AlertCircle, X } from "lucide-react";
import CaptureIcon from "./IconComponent/CaptureIcon";
import "./CaptureFeedbackModal.css";

const AUTO_CLOSE_MS = 2000;

export default function CaptureFeedbackModal({ open, variant = "success", message, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;

    const timer = window.setTimeout(() => {
      onClose?.();
    }, AUTO_CLOSE_MS);

    return () => window.clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  const isSuccess = variant === "success";

  return createPortal(
    <div
      className="capture-feedback-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div
        className={`capture-feedback-modal capture-feedback-modal--${variant}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="capture-feedback-modal-title"
      >
        <button
          type="button"
          className="capture-feedback-modal__close"
          onClick={() => onClose?.()}
          aria-label="Fermer"
        >
          <X size={18} strokeWidth={2.5} />
        </button>

        {isSuccess ? (
          <>
            <div className="capture-feedback-modal__hero" aria-hidden="true">
              <CaptureIcon size={38} color="#39210d" strokeWidth={1} />
              <span className="capture-feedback-modal__bonus">+1</span>
            </div>
            <p id="capture-feedback-modal-title" className="capture-feedback-modal__message">
              Nouveau mot enregistré dans le registre
            </p>
          </>
        ) : (
          <>
            <div className="capture-feedback-modal__hero capture-feedback-modal__hero--error" aria-hidden="true">
              <AlertCircle size={36} strokeWidth={2} />
            </div>
            <p id="capture-feedback-modal-title" className="capture-feedback-modal__message">
              {message || "Impossible d'enregistrer le mot pour le moment."}
            </p>
          </>
        )}
      </div>
    </div>,
    getAppPortalRoot()
  );
}
